/* unplugin-vue-components disabled */import script from "./indexgz.vue?vue&type=script&setup=true&lang=js"
export * from "./indexgz.vue?vue&type=script&setup=true&lang=js"

import "./indexgz.vue?vue&type=style&index=0&id=79f316d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f316d0"]])

export default __exports__